/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get */
// Ember imports
import Service from '@ember/service';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import config from '@linc-technologies/linced-common/utils/config';
// External imports
import CommentModerationStatus from '@linc-technologies/linced-common/enums/comment-moderation-status';

export default class HeroApiCommentsService extends Service {
  @service
  fetch;

  @service
  session;

  @service
  store;

  approve(id) {
    return this._statusAction(id, CommentModerationStatus.ACCEPTED);
  }

  decline(id) {
    return this._statusAction(id, CommentModerationStatus.DECLINED);
  }

  _statusAction(id, moderationStatus) {
    const moderatorId = this.get('session.personId');
    const uri = `${config.APP.apiHost}/posts/v4/comments/${id}/:moderate`;
    const payload = {
      moderatorId,
      moderationStatus,
    };
    const options = {
      data: JSON.stringify(payload),
    };

    return this.fetch.post(uri, options).then((response) => {
      if (isEmpty(response.comment)) {
        // Do not attempt to inject bad data
        return;
      }

      // push in a partial update in the way ember expects to have received
      // a payload for a comment, so it can filter down and react to changes
      // in the model.
      this.store.pushPayload('posts/comment', response);
    });
  }
}
